import { DiagramInterface } from "../interfaces/diagram";

export const mocks: DiagramInterface = {
  name: "NEW_GRAPH",
  nodes: [
    {
      id: "0105f6ff-0346-42ba-952e-9bc3a818c0ae",
      type: "StringNode",
      out_node: null,
      can_be_executed: false,
      can_execute: false,
      friendly_name: "String",
      block_type: "variable",
      _x: 64,
      _y: 297,
      in_parameters: [],
      out_parameters: [
        {
          value_is_reference: false,
          id: "bc5ea31b-45f7-4bd2-997e-dd52f34b7a4c",
          name: "value",
          type: "System.String",
          value: "Binance API Key",
          assignment: null,
          assignment_node: null,
        },
      ],
    },
    {
      id: "657ecec1-6350-46d9-ad3e-789ce6a5e3ee",
      type: "SetVariable",
      out_node: null,
      can_be_executed: true,
      can_execute: true,
      friendly_name: "Set variable",
      block_type: "function",
      _x: 480,
      _y: 336,
      in_parameters: [
        {
          value_is_reference: false,
          id: "03405b70-f3a7-4904-9093-c8368fd860a1",
          name: "variableName",
          type: "System.String",
          value: null,
          assignment: "bc5ea31b-45f7-4bd2-997e-dd52f34b7a4c",
          assignment_node: "0105f6ff-0346-42ba-952e-9bc3a818c0ae",
        },
        {
          value_is_reference: false,
          id: "317fbf39-b515-46f1-857f-f96370ab3fda",
          name: "value",
          type: "System.String",
          value: null,
          assignment: "25c74bc4-7aee-457d-b694-ff78040533b3",
          assignment_node: "310bece3-0878-4119-a16b-6f64f2aee73c",
        },
      ],
      out_parameters: [],
    },
    {
      id: "310bece3-0878-4119-a16b-6f64f2aee73c",
      type: "StringNode",
      out_node: null,
      can_be_executed: false,
      can_execute: false,
      friendly_name: "String",
      block_type: "variable",
      _x: 94,
      _y: 444,
      in_parameters: [],
      out_parameters: [
        {
          value_is_reference: false,
          id: "25c74bc4-7aee-457d-b694-ff78040533b3",
          name: "value",
          type: "System.String",
          value: "test",
          assignment: null,
          assignment_node: null,
        },
      ],
    },
    {
      id: "0fb7961d-245e-49b2-a44a-5504bf6f15e0",
      type: "EntryPointNode",
      out_node: "657ecec1-6350-46d9-ad3e-789ce6a5e3ee",
      can_be_executed: false,
      can_execute: true,
      friendly_name: "Entry Point",
      block_type: "entry-point",
      _x: 184,
      _y: 167,
      in_parameters: [],
      out_parameters: [],
    },
    {
      id: "5cfcb179-6f62-433d-96e6-653d65fd6760",
      type: "EthConnection",
      out_node: null,
      can_be_executed: false,
      can_execute: true,
      friendly_name: "Ethereum Connector",
      block_type: "connector",
      _x: 1471,
      _y: 380,
      in_parameters: [
        {
          value_is_reference: false,
          id: "d6721335-4dff-4cdc-88ad-10e172afccf7",
          name: "url",
          type: "System.String",
          value: null,
          assignment: "af1bdc04-da4d-4d42-98c0-3c12a15a8282",
          assignment_node: "6722e142-6986-4aa7-a349-3bc7a114f8b9",
        },
        {
          value_is_reference: false,
          id: "e3ad4743-f896-4770-88e7-61eb76468df4",
          name: "socketUrl",
          type: "System.String",
          value: null,
          assignment: null,
          assignment_node: null,
        },
      ],
      out_parameters: [
        {
          value_is_reference: false,
          id: "9159d3e8-dd90-47ce-bade-e7ff8c0db46b",
          name: "connection",
          type: "NodeBlock.Plugin.Ethereum.Nodes.EthConnection",
          value: null,
          assignment: null,
          assignment_node: null,
        },
      ],
    },
    {
      id: "6722e142-6986-4aa7-a349-3bc7a114f8b9",
      type: "GetVariable",
      out_node: null,
      can_be_executed: false,
      can_execute: false,
      friendly_name: "Get variable",
      block_type: "function",
      _x: 1269,
      _y: 274,
      in_parameters: [
        {
          value_is_reference: false,
          id: "ce3e2974-3d93-41cd-aeed-b4d097ecaa40",
          name: "variableName",
          type: "System.String",
          value: null,
          assignment: "fc3b4876-3035-43de-a3c5-5796c2982b7e",
          assignment_node: "acde2769-2766-4abf-b464-b8c78cc9ecca",
        },
      ],
      out_parameters: [
        {
          value_is_reference: false,
          id: "af1bdc04-da4d-4d42-98c0-3c12a15a8282",
          name: "value",
          type: "System.Object",
          value: null,
          assignment: null,
          assignment_node: null,
        },
      ],
    },
    {
      id: "acde2769-2766-4abf-b464-b8c78cc9ecca",
      type: "StringNode",
      out_node: null,
      can_be_executed: false,
      can_execute: false,
      friendly_name: "String",
      block_type: "variable",
      _x: 1038,
      _y: 291,
      in_parameters: [],
      out_parameters: [
        {
          value_is_reference: false,
          id: "fc3b4876-3035-43de-a3c5-5796c2982b7e",
          name: "value",
          type: "System.String",
          value: "test",
          assignment: null,
          assignment_node: null,
        },
      ],
    },
    {
      id: "eeb52895-c022-4a61-b3a1-1e386c632f11",
      type: "GetTransactionParametersNode",
      out_node: null,
      can_be_executed: false,
      can_execute: false,
      friendly_name: "Get Transaction Parameters",
      block_type: "function",
      _x: 761,
      _y: 474,
      in_parameters: [
        {
          value_is_reference: false,
          id: "b096f657-6c42-4e02-b504-5dc0cb5d509a",
          name: "transaction",
          type: "Nethereum.RPC.Eth.DTOs.Transaction",
          value: null,
          assignment: null,
          assignment_node: null,
        },
      ],
      out_parameters: [
        {
          value_is_reference: false,
          id: "6c66e6a4-1ac0-4d85-8901-0f0e17d47687",
          name: "etherValue",
          type: "System.Decimal",
          value: null,
          assignment: null,
          assignment_node: null,
        },
        {
          value_is_reference: false,
          id: "c37af553-d44e-4006-8d92-b4f85f5a7c63",
          name: "from",
          type: "System.String",
          value: null,
          assignment: null,
          assignment_node: null,
        },
        {
          value_is_reference: false,
          id: "bfa796d8-c27c-4a06-9016-d8374ce1668d",
          name: "to",
          type: "System.String",
          value: null,
          assignment: null,
          assignment_node: null,
        },
        {
          value_is_reference: false,
          id: "9dc459e9-f14f-459f-894d-8356e4fda8d9",
          name: "gasPrice",
          type: "System.Decimal",
          value: null,
          assignment: null,
          assignment_node: null,
        },
        {
          value_is_reference: false,
          id: "31fe0b4a-ebbf-4ab5-bc52-15449bba0d3f",
          name: "gas",
          type: "System.Decimal",
          value: null,
          assignment: null,
          assignment_node: null,
        },
        {
          value_is_reference: false,
          id: "e831dd7b-5cbf-46ac-9dc9-0588e088cf0d",
          name: "hash",
          type: "System.String",
          value: null,
          assignment: null,
          assignment_node: null,
        },
        {
          value_is_reference: false,
          id: "b6d8fc63-c11f-4ca8-9fc0-4852e0c77977",
          name: "blockHash",
          type: "System.String",
          value: null,
          assignment: null,
          assignment_node: null,
        },
        {
          value_is_reference: false,
          id: "d621c26b-5f0d-4d3b-92fe-97883ba281ac",
          name: "blockNumber",
          type: "System.Int32",
          value: null,
          assignment: null,
          assignment_node: null,
        },
        {
          value_is_reference: false,
          id: "288d3e3a-0e12-4812-9d86-c2f0e48704cd",
          name: "nonce",
          type: "System.Int32",
          value: null,
          assignment: null,
          assignment_node: null,
        },
      ],
    },
  ],
};
